import { initSignupClient } from "./signupClient/initSignupClient";

export const initCommonClients = (application: Common.IApplication): Common.IApplication => {
  return initSignupClient(application);
};
